module.exports = __webpack_public_path__ + "static/media/13.7ee25a42.gif";